export const employerStatusSelector = state => state.employerStatus;
